




















/* Created- 16 - May - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { ContentStreamArticleOwnerBatchDTO, ContentStreamArticleOwnerBatchItemDTO } from "../../Generated/ParticaAPI";
import { DateUtils } from "../../BusinessServices/dateutils";
import { eParticaAction, ParticaEvent } from "../../Models/ParticaEvent";
@Component(
	{
		name: "StreamOwnerBatchItems"
	})
export default class StreamOwnerBatchItems extends Vue {
	@Prop() private data: ContentStreamArticleOwnerBatchItemDTO[];
	private search: string = "";
	private headers: any = [
		{ text: "Owner", value: "owner" },
		{ text: "Amount", value: "amount" },
	];
}
